import {ApiResource} from 'common/util/model-resource/api-resource';
import {Model} from 'common/util/model-resource/model-resource';

import {EventDefinition} from '../queries/app-api/data-definitions-types';
import {bulkUpdate, eventDefinitionsClient, remove, update} from '../queries/query-api/event-definitions-client';

export class EventDefinitionsResource extends ApiResource<EventDefinition> {
  apiClient = eventDefinitionsClient;

  async patch(eventName: string, eventDefUpdate: Partial<EventDefinition>): Promise<Model<EventDefinition>> {
    const updateResponse = await update(this.buildUpdatePayload(eventName, eventDefUpdate));
    // individual Event Def patch returns the event def; bulk patch does not
    this.update({[eventName]: updateResponse});
    return this.getOne(eventName);
  }

  async bulkPatch(eventDefUpdates: Record<string, Partial<EventDefinition>>): Promise<void> {
    const apiPayload = Object.entries(eventDefUpdates).map(([eventName, eventDefUpdate]) => {
      return this.buildUpdatePayload(eventName, eventDefUpdate);
    });
    await bulkUpdate(apiPayload);

    this.update(eventDefUpdates);
  }

  /**
   * Delete only deletes events with non-null id.
   */
  bulkDelete(eventDefinitions: EventDefinition[]): Promise<void> {
    eventDefinitions.forEach((definition) => {
      this.delete(definition.name);
    });

    return remove(
      eventDefinitions.map((definition) => ({
        collectEverythingEventId: definition.collectEverythingEventId,
        customEventId: definition.customEventId,
        id: definition.id,
      })),
    );
  }

  //** Builds a payload including the identifier fields that the API needs. Based on LexiconApi.getBaseEventParams() */
  buildUpdatePayload(eventName: string, eventDefUpdate: Partial<EventDefinition>) {
    const eventDef = this.getOne(eventName).value;
    return {
      ...(eventDef?.collectEverythingEventId ? {collectEverythingEventId: eventDef?.collectEverythingEventId} : {}),
      ...(eventDef?.customEventId ? {customEventId: eventDef?.customEventId} : {}),
      ...(eventDef?.id ? {id: eventDef?.id} : {}),
      name: eventDef?.name,
      ...eventDefUpdate,
    };
  }
}
